import {t} from "@lingui/core/macro";
import * as React from "react";

type Props = {
    // The size used to determine the width and height of the top-level SVG
    // element.
    // TODO(charlie): Take an enum to configure these size properties.
    size: number;
    // The size used to determine the width and height of the icon itself.
    iconSize: number;
    // the color of the icon
    color?: string;
    description: string;
};

/**
 * Renders the close icon from https://zpl.io/ZWSYTR.
 */
class CloseIcon extends React.Component<Props> {
    static defaultProps: {
        color: string;
        description: string;
    } = {
        color: "currentColor",
        description: "",
    };

    componentDidMount() {
        // HACK(kevinb): remove when we upgrade to React 15
        // @ts-expect-error - TS2339 - Property 'setAttribute' does not exist on type 'ReactInstance'.
        // eslint-disable-next-line react/no-string-refs
        this.refs.g.setAttribute("stroke-linejoin", "round");
    }

    render(): React.ReactNode {
        const {size, iconSize, color} = this.props;
        const description = this.props.description || t`Closes this module.`;
        const svgProps = {
            stroke: color,
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: "none",
            fillRule: "evenodd",
        } as const;
        const start = (size - iconSize) / 2;
        const end = (size + iconSize) / 2;

        const title = t`Close`;
        const label = `${title} ${description}`;

        return (
            // We need role="img" for some browsers to read the title and description
            // information.
            <svg
                width={size}
                height={size}
                viewBox={`0 0 ${size} ${size}`}
                role="img"
                aria-label={label}
            >
                <title>{title}</title>
                <desc>{description}</desc>
                {/* eslint-disable-next-line react/no-string-refs */}
                <g ref="g" {...svgProps}>
                    <path d={`M${end},${start} L${start},${end}`} />
                    <path d={`M${start},${start} L${end},${end}`} />
                </g>
            </svg>
        );
    }
}

export default CloseIcon;
